import {useTreatment} from '@miro-site/splitio'
import {useWindowSize, getCookie} from '@miro-site/core'
import {useLocalization} from '@miro-site/localization'
import type {IExperimentAttrs} from '@mirohq-internal/experimentation-core'

/**
 * useTreatment wrapper to add default props
 */
const useTreatmentWrapper = (
  name: string,
  attrs: IExperimentAttrs = {},
): [string | undefined, boolean] => {
  const {width = 0} = useWindowSize()
  const {currentLocale} = useLocalization()

  const LG_BREAKPOINT = 992
  const isMobile = width < LG_BREAKPOINT

  return useTreatment(name, {
    locale: currentLocale,
    is_mobile: isMobile,
    is_desktop: !isMobile,
    is_bot: false, // This check is already implemented on SplitioProvider
    prospect_user: !getCookie('ajs_user_id'),
    ...attrs,
  })
}

export default useTreatmentWrapper
